import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import UserInfo from '@root/types/UserInfo';

const initialState = { value: null, withdrawalConditions: null, isTermsAndConditionsAccepted: null } as {
  value: null | UserInfo;
  withdrawalConditions: null | UserInfo;
  isTermsAndConditionsAccepted: boolean | null;
};

export const userInfoSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<UserInfo>) {
      state.value = action.payload;
    },
    setUser(state, action: PayloadAction<UserInfo | null>) {
      state.value = action.payload;
    },
    setWithdrawalConditions(state, action: PayloadAction<UserInfo | null>) {
      state.withdrawalConditions = action.payload;
    },
    setTermsAndConditionsAccepted(state, action: PayloadAction<boolean | null>) {
      state.isTermsAndConditionsAccepted = action.payload;
    },
  },
});

export const { setUserInfo, setUser, setWithdrawalConditions, setTermsAndConditionsAccepted } =
  userInfoSlice.actions;

export default userInfoSlice.reducer;
